import { render, staticRenderFns } from "./SampleDextEditor.vue?vue&type=template&id=5944d0e5"
import script from "./SampleDextEditor.vue?vue&type=script&lang=js"
export * from "./SampleDextEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5944d0e5')) {
      api.createRecord('5944d0e5', component.options)
    } else {
      api.reload('5944d0e5', component.options)
    }
    module.hot.accept("./SampleDextEditor.vue?vue&type=template&id=5944d0e5", function () {
      api.rerender('5944d0e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/SampleDextEditor.vue"
export default component.exports